/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Get Dashboard Info (GET)
export const fetchDashboardData = createAsyncThunk('get dashboard data', async () => {
  let response = [null, null];
  try {
    const res = await $axios.get('/admin/dashboard-info');
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Slice
const dasboardSlice = createSlice({
  name: 'dasboardSlice',
  initialState: {
    dashboardData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.dashboardData = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
      });
  },
});

export default dasboardSlice.reducer;
